module.exports = __webpack_public_path__ + "media/images/golden_pin_design_award_logo-2fe9ff258dccebc9e002ef7ef68a3492.png";